import { render, staticRenderFns } from "./profile-view-trainings.vue?vue&type=template&id=723826b1&scoped=true&"
import script from "./profile-view-trainings.vue?vue&type=script&lang=js&"
export * from "./profile-view-trainings.vue?vue&type=script&lang=js&"
import style0 from "./profile-view-trainings.vue?vue&type=style&index=0&id=723826b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723826b1",
  null
  
)

export default component.exports